const locale = {
    locale: "en_GB",
    yearFormat: "YYYY",
    monthFormat: "MMMM",
    fieldDateFormat: "MMM dd yyyy",
    dayFormat: "DD",
    monthBeforeYear: true,
};
export default locale;
